/**
 * Форматирует оценку рейтинга с одной цифрой после точки (например `5.0`).
 *
 * Округление математическое: 0,5 вверх (как `Math.round`).
 */
export default function formatRatingScore(value: number): string {
  return (Math.round(value * 10) / 10).toFixed(1)
}
